import * as classnames from 'classnames/bind';
import * as React from 'react';
import {AppConfig} from 'src/AppConfig';
import {GetStartedArea} from 'src/components/common/GetStartedArea';
import {GetStartedDialog2} from 'src/components/dialogs/getStarted2/GetStartedDialog2';
import Footer from 'src/components/pages/home2/pageCommon/Footer';
import PageNav, {PageName} from 'src/components/pages/home2/pageCommon/PageNav';
import {GatsbySSRUtil} from 'src/util/GatsbySSRUtil';

const styles = require('./Page2.module.less');
const cx = classnames.bind(styles) as any;

export interface Page2State
{
	email?:string;
	isGetStartedDialogOpened:boolean;
}

export interface Page2Props
{
	pageName:PageName;
	contentClassName?:string;
	showGetStartedDialog?:boolean;
	onGetStartedDialogClosed?:() => void;
}

export class Page2 extends React.Component<Page2Props, Page2State>
{
	constructor(props:Page2Props)
	{
		super(props);

		this.state = {isGetStartedDialogOpened: false};
	}

	componentDidMount()
	{
		if( !GatsbySSRUtil.hasWindow() )
			return;
	}

	componentWillReceiveProps(nextProps:Readonly<Page2Props>, nextContext:any):void
	{
		const {showGetStartedDialog} = this.props;

		if( nextProps.showGetStartedDialog !== showGetStartedDialog )
		{
			this.setState({isGetStartedDialogOpened: nextProps.showGetStartedDialog});
		}
	}

	render()
	{
		const {isGetStartedDialogOpened, email} = this.state;
		const {contentClassName, pageName} = this.props;

		return (
			<div className={cx('page')}>

				<div className={cx('bgRadial')} />

				<PageNav
					pageName={pageName}
					showGetStarted={true}
					onEmailEntered={this._onEmailEntered}
				/>

				<div className={cx(contentClassName, 'content')}>

					{this.props.children}

				</div>

				<div className={cx('getStarted')}>
					<GetStartedArea
						isFlat={true}
						className={cx('getStartedArea')}
						hsFormId={AppConfig.getHubSpotStartedFormId()}
						onEmailEntered={this._onEmailEntered}
					/>
				</div>

				<GetStartedDialog2
					email={email}
					isOpened={isGetStartedDialogOpened}
					onDialogClosed={() =>
					{
						const {onGetStartedDialogClosed} = this.props;
						this.setState({isGetStartedDialogOpened: false});

						if( onGetStartedDialogClosed ) onGetStartedDialogClosed();
					}}
				/>

				<Footer />
			</div>
		);
	}

	private _onClickGetStated = (e:React.MouseEvent<HTMLElement>) =>
	{
		this.setState({isGetStartedDialogOpened: true});
	};

	private _onEmailEntered = (email:string) =>
	{
		this.setState({email, isGetStartedDialogOpened: true});
	};
}
